import React, {Component} from 'react'
import Article from './article'

class Policy extends Component {
    render() {
        return (
            <div>
                <Article text="Todos os conteúdos presentes neste website são apenas para fins informativos e
                         não devem ser considerados completos ou atualizados. Além disso, não são destinados
                         para serem utilizados como: consulta jurídica, consulta médica, consulta financeira
                          ou relacionados à qualquer outro âmbito profissional. Os conteúdos são fornecidos
                          sem qualquer tipo de garantia. Todo e qualquer risco da utilização dos conteúdos
                          é assumido pelo próprio usuário."
                />

                <Article title="Se você não concorda com a política de uso não use o site."/>

            </div>
        )
    }
}

export default Policy


// WEBPACK FOOTER //
// ./src/policy.jsx